<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Main Banners</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()">
        <v-icon>autorenew</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-card>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex
              v-for="item in items"
              md4
              xs12
              :key="item.bannerId"
            >
              <v-card flat :to="'/banner/main/' + item.bannerId">
                <v-img :src="item.largeUrl" aspect-ratio="1.2"></v-img>
                <v-card-actions>
                  <v-container fluid grid-list-md fill-height pa-1>
                    <v-layout>
                      <v-flex xs12 align-end flexbox>
                        <div class="subheading" style="font-weight:bold;" v-if="item.linkToProductName!=''">#{{ item.orderSequence }} PRODUCT: {{ item.linkToProductName }}</div>
                        <div class="subheading" style="font-weight:bold;" v-else-if="item.linkToCategoryName!=''">#{{ item.orderSequence }} CATEGORY: {{ item.linkToCategoryName }}</div>
                        <div class="subheading" style="font-weight:bold;" v-else>#{{ item.orderSequence }} Url: {{ (item.url === '' ? '-' : item.url) }}</div>
                        <div class="caption grey--text">Created on: {{ item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex
              v-if="items.length <= 0"
              xs12
              justify-center
              align-center
              text-xs-center
            >
              <v-icon x-large color="primary">error_outline</v-icon>
              <div>
                No banner yet
              </div>
            </v-flex>
          </v-layout>

        </v-container>
      </v-card>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          to="/banner/main"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      drawer: false,
      loading: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getBanners()
    this.detectBottomOfWindow()
  },

  methods: {
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getBanners(_this.items.length, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48
        // console.log(document.documentElement.offsetHeight)
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getBanners(this.items.length)
          }
        }
      }
    },
    getBanners: function (offset = 0) {
      var _this = this
      _this.loading = true
      var promise = new Promise(function (resolve, reject) {
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/banners?limit=' + _this.listLimit + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.items = _this.items.concat(resp.data.data)
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
            } else {
              console.log('unable to load banners: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
